import config from '../config';

export const getAllCoinLogs = async () => {
  const response = await fetch(`${config.apiUrl}/coinLogs`);
  if (!response.ok) throw new Error('Failed to fetch coin logs');
  return response.json();
};

export const createCoinLog = async (data) => {
  const response = await fetch(`${config.apiUrl}/coinLogs`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to create coin log');
  }
  return response.json();
};

export const filterCoinLogs = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await fetch(`${config.apiUrl}/coinLogs/filterRecharge/get?${query}`);
  if (!response.ok) throw new Error('Failed to fetch recharge tracking records');
  return response.json();
};

export const createCoinClearance = async (id, data) => {
  const response = await fetch(`${config.apiUrl}/coinLogs/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to update coin log clearance status');
  }

  return response.json();
};
